import { useCallback } from "react";
import { useVisitorData } from "@fingerprintjs/fingerprintjs-pro-react";

export type FingerprintResult = {
  deviceId: string;
  deviceRequestId: string;
};

export type FingerprintDataType = {
  deviceId: string;
  deviceRequestId: string;
  error: Error | undefined;
  captureData: () => Promise<FingerprintResult>;
};

export const useFingerPrintData = (action: string): FingerprintDataType => {
  const { getData, data, error } = useVisitorData(
    { extendedResult: true, tag: { userAction: action } },
    { immediate: true }
  );

  const captureData = useCallback(async (): Promise<FingerprintResult> => {
    try {
      const result = await getData();
      return {
        deviceId: result.visitorId,
        deviceRequestId: result.requestId,
      };
    } catch (err) {
      console.warn("Fingerprint collection failed:", err);
      return { deviceId: "", deviceRequestId: "" };
    }
  }, [getData]);

  return {
    deviceId: data?.visitorId ?? "",
    deviceRequestId: data?.requestId ?? "",
    error,
    captureData,
  };
};
